import styled from "styled-components";

export const Container = styled.div`
    align-self: flex-end;
    display: flex;
    justify-content: center;
    gap: 10px;

    svg {
        margin: 1rem 0;
     }

    a {
        color: #141414;
    }
`